module.exports = __webpack_public_path__ + "img/epk-photo-main.4c2f069c.jpeg";